import React, { Component } from 'react';
import moment from 'moment';
// import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import Chart from 'react-apexcharts';
// import classNames from 'classnames';
// import FormattedNumberCustom from '../../../../../../
// ../../../app/components/formatted-number-custom';

class Graph extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: {
        stroke: {
          show: true,
          curve: 'straight',
          width: [0, 2, 0],
        },
        tooltip: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        chart: {
          width: '100%',
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: ['#000000', '#5fa227', '#5fa227'],
            fontSize: '12px',
            fontFamily: 'HKGrotesk, sans-serif',
            cssClass: 'apexcharts-xaxis-label',
          },
        },
        xaxis: {
          categories: this.getMonths(props.orders),
          labels: {
            show: true,
            style: {
              fontSize: '14px',
              fontFamily: 'NeueEinstellung, sans-serif',
              cssClass: 'apexcharts-xaxis-label',
            },
          },
          axisBorder: {
            show: true,
            color: '#78909C',
            offsetX: 0,
            offsetY: 1,
          },
        },
        grid: {
          show: false,
        },
        markers: {
          size: [5, 7],
          colors: '#5fa227',
          strokeWidth: 0,
          fillOpacity: 1,
          shape: 'circle',
        },
        colors: ['#f8de65', '#5fa227'],
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 0,
          },
        },
        yaxis: {
          show: true,
          axisBorder: {
            show: true,
            color: '#78909C',
            offsetX: 2,
            offsetY: 0,
          },
          min: 0,
        },
        plotOptions: {
          bar: {
            columnWidth: '50%',
            dataLabels: {
              position: 'bottom',
            },
          },
        },
      },
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.orders !== prevProps.orders) {
      const months = this.getMonths(this.props.orders);
      // Only update if months actually changed to prevent infinite loop
      const currentCategories = this.state.options.xaxis.categories;
      const monthsChanged = JSON.stringify(currentCategories) !== JSON.stringify(months);

      if (monthsChanged) {
        this.setState({
          options: {
            ...this.state.options,
            xaxis: {
              ...this.state.options.xaxis,
              categories: months,
            },
          },
        });
      }
    }
  }

  getMonths = (orders) => {
    const months = [];
    Object.keys(orders).sort().forEach((mnthIdx) => {
      months.push(moment().month(mnthIdx - 1).format('MMMM'));
    });
    return months;
  }

  render() {
    const { props: { orders } } = this;
    const currentData = [];
    const targetsData = [];
    const acheivedData = [];
    const months = [];
    Object.keys(orders).sort().forEach((mnthIdx) => {
      const monthData = orders[mnthIdx];
      months.push(moment().month(mnthIdx - 1).format('MMMM'));
      if (monthData.total_quantity) {
        currentData.push(Number(monthData.total_quantity).toFixed(2));
      } else {
        currentData.push(null);
      }

      let target = null;
      let prevTarget = null;
      if (monthData.target_data && monthData.target_data.length > 0) {
        for (let i = 0; i < monthData.target_data.length; i += 1) {
          const data = monthData.target_data[i];
          prevTarget = target;
          target = data.target;
          if (target > monthData.total_quantity) {
            break;
          }
        }
      }
      targetsData.push(target);
      acheivedData.push(prevTarget);
    });
    // console.log('orders', orders);
    // console.log('months', months);
    // console.log('currentData', currentData);
    // console.log('targetsData', targetsData);
    // console.log('acheivedData', acheivedData);
    const series = [
      {
        type: 'column',
        data: currentData,
      },
    ];

    if (targetsData.some(element => element > 0)) {
      series.push({
        type: 'line',
        data: targetsData,
      });
    }

    if (acheivedData.some(element => element > 0)) {
      series.push({
        type: 'line',
        data: acheivedData,
      });
    }

    // console.log('options', this.state.options);
    // console.log('series', series);
    return (
      <div className="graph-svg">
        <Chart options={this.state.options} series={series} width={300} height={320} />
      </div>
    );
  }
}

Graph.propTypes = {
  orders: PropTypes.shape({}).isRequired,
  highestBagsCount: PropTypes.number.isRequired,
  user: PropTypes.shape({}).isRequired,
};

export default Graph;
